import React, {Component} from 'react';
import Slider from "../../utils/slider/slider";
import client1 from '../../assets/logo/client1.png';
import client2 from '../../assets/logo/client2.png';
import client3 from '../../assets/logo/client3.png';
import client4 from '../../assets/logo/client4.png';
import client6 from '../../assets/logo/client6.png';
import client7 from '../../assets/logo/client7.png';
import client8 from '../../assets/logo/client8.png';
import client9 from '../../assets/logo/client9.png';
import client10 from '../../assets/logo/client10.png';

const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 5000,
    cssEase: "linear"
};

class FeatureClients extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [
                <div key={1} className="item"><img src="../../assets/logo/client1.png" alt="The Last of us" /></div>,
                <div key={2} className="item"><img src="../../assets/logo/client2.png" alt="GTA V" /></div>,
                <div key={3} className="item"><img src="../../assets/logo/client3.png" alt="Mirror Edge" /></div>,
            ]
        }
    }

    render() {
        return (
            <div className='section'>
                <div className="container">
                    <div className="row" style={{padding:'50px 0'}}>
                        <div className={'col-md-12 feature-client'}>
                            <h4 className='text-center title'>
                                Our Clients and Partners
                            </h4>
                        </div>
                    </div>
                    <div>
                        <div className="col-md-12">
                            <Slider {...settings}>
                                <div>
                                    <img className='clients-images' src={client1} alt="The Last of us" />
                                </div>
                                <div>
                                    <img className='clients-images' src={client2} alt="The Last of us" />
                                </div>
                                <div>
                                    <img className='clients-images' src={client3} alt="The Last of us" />
                                </div>
                                <div>
                                    <img className='clients-images' src={client4} alt="The Last of us" />
                                </div>
                                <div>
                                    <img className='clients-images' src={client6} alt="The Last of us" />
                                </div>
                                <div>
                                    <img className='clients-images' src={client7} alt="The Last of us" />
                                </div>
                                <div>
                                    <img className='clients-images' src={client8} alt="The Last of us" />
                                </div>
                                <div>
                                    <img className='clients-images' src={client9} alt="The Last of us" />
                                </div>
                                <div>
                                    <img className='clients-images' src={client10} alt="The Last of us" />
                                </div>
                            </Slider>

                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
export default FeatureClients;




// WEBPACK FOOTER //
// ./src/views/home/featured-clients.js